import { Dialog, useDialog } from "@fpsoftware/mvp";
import { zodResolver } from "@hookform/resolvers/zod";
import { useQueryClient } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { TbDeviceFloppy } from "react-icons/tb";
import { AddressUpdateValueBodySchema } from "shared";
import { useSuspenseAddress } from "@/addresses/hooks";
import { Api } from "@/api.config";
import { Button } from "@/components/Button";
import { NumberInput } from "@/components/form/NumberInput";
import { QueryKeys } from "@/LinkGen";
import { invalidateMortgagesWithAddressID } from "@/mortgages/hooks";

export const UpdateAddressValueDialog = (props: { addressID: number }) => {
  const address = useSuspenseAddress(props.addressID);
  const dialog = useDialog();

  const { handleSubmit, formState, control } = useForm({
    resolver: zodResolver(AddressUpdateValueBodySchema),
    defaultValues: {
      amount: Number(address.value ?? 0),
    },
  });
  const queryClient = useQueryClient();

  const onSubmit = handleSubmit(async (values) => {
    await Api.AddressUpdateValue(props.addressID, values);
    await queryClient.refetchQueries({
      queryKey: QueryKeys.Address(props.addressID),
    });
    await invalidateMortgagesWithAddressID(queryClient, props.addressID);
    dialog.close();
  });

  return (
    <form onSubmit={onSubmit}>
      <Dialog.Header>Update property value</Dialog.Header>
      <Dialog.Body>
        <NumberInput
          label="Property value"
          placeholder="Property value"
          autoFocus
          control={control}
          name="amount"
          required
        />
      </Dialog.Body>
      <Dialog.Footer>
        <Button
          icon={TbDeviceFloppy}
          type="submit"
          loading={formState.isSubmitting}
        >
          Save
        </Button>
      </Dialog.Footer>
    </form>
  );
};
